export const ESCROWS_LIMIT = 12;
export const DEPOSITS_PER_PAGE = 20;
export const ASSETS_LIMIT = 10;
export const LEGACY_REPOS_LIMIT = 20;
export const INTEGRATIONS_LIMIT = 20;
export const UPLOAD_SIZE_LIMIT = Math.pow(2, 30) * 30; // 30GB
export const EXCLUSIVE_OFFER = 40;
export const REPORTS_LIMIT = 10;
export const CUSTODIAN_INTEGRATION_LIMIT = 10;
export const BACKUPS_LIMIT = 12;
export const ESCROW_MEMBERS_LIMIT = 50;
export const NOTIFICATIONS_LIMIT = 10;
export const CUSTODIAN_PROFILES_LIMIT = 12;
export const USERS_LIMIT = 10;
export const CONTINUITY_ESCROWS_LIMIT = 12;
export const SAAS_ESCROWS_LIMIT = 12;

// Dashboard filters storage keys
export const CONTINUITY_ESCROWS_FILTER_STORAGE_KEY = 'continuity_escrows_filters';
export const SOFTWARE_ESCROWS_FILTER_STORAGE_KEY = 'software_escrows_filters';
export const SAAS_ESCROWS_FILTER_STORAGE_KEY = 'saas_escrows_filters';
export const CUSTODIAN_PROFILES_FILTER_STORAGE_KEY = 'custodian_profiles_filters';
export const BACKUPS_FILTER_STORAGE_KEY = 'backups_filters';

export const PROVIDER_KEY_TO_NAME = {
  azure: 'Azure',
  bitbucket: 'Bitbucket',
  gcp: 'GCP',
  gitlab: 'GitLab',
  github: 'GitHub',
  github_server: 'GitHub Enterprise',
  gitlab_server: 'GitLab Self-Managed',
  codecommit: 'Amazon CodeCommit',
  aws: 'Amazon S3',
  share_file_https: 'Sharefile',
  azure_devops: 'Azure DevOps',
  azure_devops_legacy: 'Azure DevOps (Legacy)',
  bitbucket_server: 'Bitbucket Server',
  beanstalk: 'Beanstalk',
};

export const PROVIDERS_WITH_USERNAME = ['gitlab_server', 'github_server', 'bitbucket_server', 'beanstalk'];

export const REPORTS_START_DATE = '2024-06-01';

export enum OtherEscrowStatusEnum {
  TerminationRequested = 'terminationRequested',
  TerminationRequestedSuggester = 'terminationRequestedSuggester',
  TerminationRequestedReceiver = 'terminationRequestedReceiver',
  TerminationRequestedReceiverViewer = 'terminationRequestedReceiverViewer',
  SignedDepositor = 'signedDepositor',
  SignedBeneficiary = 'signedBeneficiary',
  SignedWithDeposits = 'signedWithDeposits',
  RequestingChanges = 'requestingChanges',
  ChangesRequested = 'changesRequested',
  ChangesRequestedSuggester = 'changesRequestedSuggester',
  ChangesRequestedReceiver = 'changesRequestedReceiver',
  ChangesRequestedInReview = 'changesRequestedInReview',
  AwaitingSignature = 'awaitingSignature',
  ActivationProcess = 'activationProcess',
  Rejected = 'rejected',
}

export enum OtherContinuityEscrowStatusEnum {
  SignedDepositor = 'signedDepositor',
  SignedBeneficiary = 'signedBeneficiary',
  PendingActivationDepositor = 'pendingActivationDepositor',
  PendingActivationBeneficiary = 'pendingActivationBeneficiary',
  ProvidersConfirmedDepositor = 'providersConfirmedDepositor',
  ProvidersConfirmedBeneficiary = 'providersConfirmedBeneficiary',
  UnconfirmedProviderDepositor = 'unconfirmedProviderDepositor',
  UnconfirmedProviderBeneficiary = 'unconfirmedProviderBeneficiary',
  AccessIssuesProviderDepositor = 'accessIssuesProviderDepositor',
  AccessIssuesProviderBeneficiary = 'accessIssuesProviderBeneficiary',
  ProviderIssuesDetectedDepositor = 'providerIssuesDetectedDepositor',
  ProviderIssuesDetectedBeneficiary = 'providerIssuesDetectedBeneficiary',
}

export enum OtherCustodianProfileStatusEnum {
  TerminationRequested = 'terminationRequested',
}

export enum OtherBackupStatusEnum {
  PendingActivation = 'pendingActivation',
}
